package one.healthium.log_food.data

import co.touchlab.kermit.Logger
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.functions.functions
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.builtins.ListSerializer
import one.healthium.db.dao.FoodDao
import one.healthium.log_food.domain.FoodModel
import one.healthium.log_food.domain.FoodRepository

class AppFoodRepository(
    private val foodMapper: FoodMapper,
    private val foodDao: FoodDao
) : FoodRepository {
    override suspend fun suggestions(keyword: String): List<FoodModel> {
        return foodDao.getFoods(keyword)
            .map { foodMapper.entityToModel(it) }
            .sortedWith(compareBy { it.product.indexOf(keyword, ignoreCase = true) })
    }

    override suspend fun searchFoodByName(query: String): List<FoodModel> {
        Logger.d("searchFoodByName: $query")
        val response = Firebase.functions
            .httpsCallable("getFoodNutritionDataV2")
            .invoke(Request(name = query))
            .data(ListSerializer(FoodDto.serializer()))

        Logger.d("foods: $response")

        return response.map(foodMapper::dtoToModel)
    }

    override suspend fun searchFoodByCode(barcode: String): List<FoodModel> {
        Logger.d("searchFoodByCode: $barcode")
        val response = Firebase.functions
            .httpsCallable("getFoodNutritionDataV2")
            .invoke(Request(code = barcode))
            .data(ListSerializer(FoodDto.serializer()))

        Logger.d("foods: $response")

        return response.map(foodMapper::dtoToModel)
    }
}

@Serializable
private data class Request(
    @SerialName("food") val name: String? = null,
    @SerialName("code") val code: String? = null,
)